/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { Icon } from 'semantic-ui-react';
import { deleteDisplayAC } from '../../action-creators';
import DisplayForm from '../forms/display-form';
import EditItemDialog from '../dialogs/edit-item-dialog';
import confirmDialog from '../confirm-dialog';
import { CardAttr } from '../widgets/card-attr';
import { DeviceStatus } from '../device-status';
import { getDisplayLink } from '../../utils/device-utils';
import styled from 'styled-components';
import { colors } from '../../themes';

import formatLastSeenOnline from '../../utils/format-last-seen-online';

const Container = styled.div`
  padding: 1em;
  span.led,
  i.tv {
    margin-right: 0.5em;
  }
`;
const Header = styled.section`
  display: grid;
  grid-template-columns: 1fr auto;
`;
const Actions = styled.div`
  i {
    cursor: pointer;
  }
  i.remove {
    color: ${colors.baseColors.red};
    margin-right: 0px;
  }
`;
const Content = styled.section`
  display: grid;
  grid-gap: 4px;
  time {
    margin-right: 1em;
  }
`;
function Title(props: any) {
  return (
    <span>
      <Icon name="tv" />
      <DeviceStatus connectionStatus={props.connectionStatus} title={props.name} />
    </span>
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function DisplayCard(props: any) {
  const isWebDisplay = props.displayType === 'web';
  return (
    <Container>
      <Header>
        <h3>
          <Title {...props} />
        </h3>
        <Actions>
          <EditItemDialog form={DisplayForm} {...props} />
          <Icon
            name="remove circle"
            onClick={() => confirmDialog(() => props.dispatch(deleteDisplayAC(props._id)))}
            size="large"
          />
        </Actions>
      </Header>
      <Content>
        <CardAttr title="Last seen online">{formatLastSeenOnline(props.lastSeenOnline)}</CardAttr>
        {isWebDisplay && (
          <CardAttr title="Link">
            <a href={getDisplayLink(props.uuid, props.secret)} target="_blank">
              Display app
            </a>
          </CardAttr>
        )}
        <CardAttr title="Queues">
          {props.queues.map((q: any) => (
            <span key={q._id}>{`${q.sequenceId} ${q.name}`}, </span>
          ))}
        </CardAttr>
        <CardAttr title="Booths">
          {props.booths.map((q: any) => (
            <span key={q._id}>{`${q.uuid} ${q.name}`}, </span>
          ))}
        </CardAttr>
        <CardAttr title="uuid">{props.uuid}</CardAttr>
        <CardAttr title="secret">{props.secret}</CardAttr>
        <CardAttr title="layoutName">{props.layoutName}</CardAttr>
        <CardAttr title="themeName">{props.themeName}</CardAttr>
        <CardAttr title="logoUrl">{props.logoUrl}</CardAttr>
        <CardAttr title="Display Type">{props.displayType}</CardAttr>{' '}
        <CardAttr title="CBX">{props.controlBox.uuid}</CardAttr>
      </Content>
    </Container>
  );
}
